import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';

import SubcategoryItemModuleCss from './SubcategoryItem.module.css';
import { QuestionList } from '~/components/QuestionList/QuestionList';
import type { Subcategory } from '~/models/supportCenter';

const block = bemCssModules(SubcategoryItemModuleCss);

export const SubcategoryItem: VFC<Subcategory> = ({ Questions, Title }) => (
  <div className={block()}>
    <h1 className={block('title')}> {Title} </h1>
    <QuestionList
      isShowMoreEnabled
      questionList={Questions}
    />
  </div>
);
